(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      /* Az ELSŐ mérés szándékosan szinkron: ekkor még nincs mit érvénytelenítenie, és a
         `--header-height` kell a ragadós elemekhez már az első festésnél. */
      this.updateHeaderMetrics();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      /* A fejléc-csoport magassága utólag is változhat (betűtípus-betöltés, a
         márkasáv tartalma, sortörés) — ResizeObserverrel követjük, különben a
         ragadós szűrő-oldalsáv elavult értékkel a fejléc mögé csúszhat. */
      if (window.ResizeObserver) {
        this.bnkStickObserver = new ResizeObserver(() => this.setStickyBottom());
        document.querySelectorAll('.shopify-section-group-header-group').forEach((s) => this.bnkStickObserver.observe(s));
      }
      window.addEventListener('load', () => this.setStickyBottom(), { once: true });

      this.onResizeHandler = this.setHeaderHeight.bind(this);
      window.addEventListener('resize', this.onResizeHandler);

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    /* BIONIKA 2026-09-09 — KÉNYSZERÍTETT ÚJRASZÁMÍTÁS megszüntetése.

       Régen: a `resize`, a ResizeObserver és a matchMedia minden jelzésére azonnal MÉRT
       (`offsetHeight`, `getComputedStyle().position`), majd ÍRT egy CSS-változót a
       gyökérre — ami az egész dokumentum stílusait érvénytelenítette, így a következő
       mérés teljes stílus- és elrendezés-újraszámítást kényszerített ki. A PSI a
       főoldalon 35 ms-ot (HU) / 103 ms-ot (EN) mért erre.

       Innentől: minden mérés EGY rAF-ben, egyszerre fut (a több jelzés egy képkockán
       belül összeolvad), az olvasás és az írás szét van választva, és a változót csak
       akkor írjuk ki, ha ténylegesen változott — így a ResizeObserver sem sül el újra a
       saját írásunk miatt. A `setHeaderHeight`/`setStickyBottom` vékony burkolóként
       megmarad, hogy a meglévő hívási helyek változatlanok maradjanak. */
    scheduleHeaderMetrics() {
      if (this.metricsRaf) return;
      this.metricsRaf = requestAnimationFrame(() => {
        this.metricsRaf = 0;
        this.updateHeaderMetrics();
      });
    }

    updateHeaderMetrics() {
      try {
        // 1) OLVASÁS — minden mérés egyben, közben SEMMIT nem írunk.
        const headerHeight = this.header ? this.header.offsetHeight : 0;
        let bottom = 0;
        document.querySelectorAll('.shopify-section-group-header-group').forEach((section) => {
          if (getComputedStyle(section).position === 'sticky') bottom += section.offsetHeight;
        });

        // 2) ÍRÁS — csak a ténylegesen változó értékek.
        const root = document.documentElement;
        const h = `${headerHeight}px`;
        if (this.lastHeaderHeight !== h) {
          this.lastHeaderHeight = h;
          root.style.setProperty('--header-height', h);
        }
        const b = `${Math.round(bottom)}px`;
        if (this.lastStickBottom !== b) {
          this.lastStickBottom = b;
          root.style.setProperty('--bnk-header-stick-bottom', b);
        }
      } catch (e) {}
    }

    setHeaderHeight() {
      this.scheduleHeaderMetrics();
    }

    /* A ragadós fejléc-csoport (hirdetősáv + fejléc) tényleges alsó éle. Enélkül a
       kollekció oldal ragadós szűrő-oldalsávja a menü alá csúszik görgetéskor. */
    setStickyBottom() {
      this.scheduleHeaderMetrics();
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
      window.removeEventListener('resize', this.onResizeHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);
  

  } catch(e) { console.error(e); }
})();
})();
